<template>
    <v-form v-model="valid" ref="localizacion" lazy-validation>
        <v-row>
            <Direcciones v-model="showDireccionesDialog" @updateAddress="updateAddress($event)"></Direcciones>
            <v-col cols="12" sm="4">
                <v-autocomplete clearable
                                :items="zones"
                                item-text="nombre"
                                @input="getSectors()"
                                label="Zona"
                                return-object
                                v-model="zone">
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete clearable
                                :disabled="!zone"
                                item-text="nombre"
                                :items="sectors"
                               @input="getNeighborhoods()"
                                label="Sector"
                                return-object
                                v-model="sector">
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete clearable
                                :disabled="!sector"
                                item-text="nombre"
                                return object
                                :items="neighborhoods"
                                label="Barrio"
                                multiple
                                :search-input.sync="searchBarrio"
                                @input="searchBarrio = null"
                                v-model="neighborhood">
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-select label="Estrato"
                          :items="constants.stratum"
                          :rules="[rules.required]"
                          clearable>
                </v-select>
            </v-col>

            <v-col cols="12" sm="8">
                <v-text-field v-model="direccion"
                              label="Dirección"
                              readonly
                              @click="showDireccionesDialog = true"
                              :rules="[rules.required]"
                              clearable>
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field v-model="urbanizacion"
                              @input="urbanizacion = urbanizacion.toUpperCase()"
                              label="Urbanización"
                              clearable></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field label="Número de apartamento" clearable></v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field v-model="date"
                              label="Año de antiguedad"
                              :rules="[rules.required]"
                              :hint="antiquity()"
                              maxlength="4"
                              persistent-hint
                              clearable>
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-autocomplete :items="constants.closedUnit"
                                label="Unidad cerrada"
                                clearable>
                </v-autocomplete>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field label="Latitud"
                              :value="latitud">
                </v-text-field>
            </v-col>

            <v-col cols="12" sm="4">
                <v-text-field label="Longitud"
                              :value="longitud">
                </v-text-field>
            </v-col>

            <v-col cols="12">
                <v-text-field id="pac-input"
                              placeholder="Buscar localidad"
                              v-model="busqueda">
<!--                    <template #append>-->
<!--                        <v-icon style="cursor: pointer" @click="emitPlacesChangedEvent()">search</v-icon>-->
<!--                    </template>-->
                </v-text-field>
            </v-col>

            <v-col cols="12">
                <div class="google-map" :id="mapName"></div>
            </v-col>

            <v-col cols="12">
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="abadPrimary" @click="submit" dark>Continuar</v-btn>
                </v-card-actions>
            </v-col>
        </v-row>
    </v-form>
</template>

<script>
import constants from '@/pages/RealEstate/libs/constants.js'
import Direcciones from '@/pages/RealEstate/components/Direcciones.vue'
import { mapState } from 'vuex'
import moment from 'moment'
import rules from '@/libs/rules'
export default {
  components: {
    Direcciones
  },
  computed: {
    ...mapState({
      neighborhoods: state => state.realEstate.neighborhoods,
      sectors: state => state.realEstate.sectors,
      zones: state => state.realEstate.zones
    })
  },
  async created () {
    try {
      await this.$store.dispatch('getZones')
    } catch (e) {
      console.log(e)
    }
  },
  data () {
    return {
      busqueda: '',
      constants,
      date: '',
      direccion: '',
      input: null,
      latitud: '',
      longitud: '',
      map: null,
      mapName: 'geo-map',
      marker: null,
      neighborhood: null,
      rules,
      searchBox: null,
      searchBarrio: '',
      sector: null,
      showDireccionesDialog: false,
      urbanizacion: '',
      valid: true,
      zone: null
    }
  },
  methods: {
    submit () {
      const stateForm = this.$refs.localizacion.validate()
      this.$emit('updateStateForm', stateForm)
      // if (!stateForm) return
    },
    addMarker (coord) {
      const position = new window.google.maps.LatLng(coord.lat, coord.lng)

      this.marker = new window.google.maps.Marker({
        id: 'marker',
        position,
        draggable: true,
        animation: window.google.maps.Animation.DROP,
        map: this.map,
        zIndex: 1
      })

      this.marker.addListener('mouseup', () => {
        this.map.setZoom(14)
        this.map.setCenter(this.marker.getPosition())
        this.latitud = this.marker.position.lat()
        this.longitud = this.marker.position.lng()
      })
    },
    antiquity () {
      if (this.date && this.date.length === 4 && parseInt(this.date) <= new Date().getFullYear()) {
        const years = moment().diff(this.date + '-01-01', 'years')
        if (years === 0) return 'Este año'
        if (years === 1) return 'Hace 1 año'
        return `Hace ${years} años`
      }
      return 'Escriba un año válido'
    },
    emitPlacesChangedEvent () {
      window.google.maps.event.trigger(this.searchBox, 'places_changed')
    },
    async getNeighborhoods () {
      try {
        this.neighborhood = null
        if (!this.sector) return
        await this.$store.dispatch('getNeighborhoods', this.sector)
      } catch (e) {
        console.log(e)
      }
    },
    async getSectors () {
      try {
        this.neighborhood = null
        this.sector = null
        if (!this.zone) return
        await this.$store.dispatch('getSectors', this.zone)
      } catch (e) {
        console.log(e)
      }
    },
    handleLocationError (browserHasGeolocation) {
      console.log('estoy en error')
    },
    updateAddress (address) {
      this.busqueda = address
      this.direccion = address
    },
    updatePosition (place) {
        this.marker.setPosition(new google.maps.LatLng(this.latitud, this.longitud)) // eslint-disable-line

      const bounds = new window.google.maps.LatLngBounds()
      if (!place.geometry) {
        console.log('Returned place contains no geometry')
        return
      }

      if (place.geometry.viewport) {
        bounds.union(place.geometry.viewport)
      } else {
        bounds.extend(place.geometry.location)
      }
      this.map.fitBounds(bounds)
    }
  },
  mounted () {
    const element = document.getElementById(this.mapName)
    const options = {
      zoom: 14,
      center: new window.google.maps.LatLng(4.570868, -74.29733299999998),
      streetViewControl: false,
      mapTypeId: 'roadmap'
    }

    this.map = new window.google.maps.Map(element, options)

    if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(position => {
        const pos = {
          lat: position.coords.latitude,
          lng: position.coords.longitude
        }

        this.map.setCenter(pos)
        this.addMarker(pos)
      }, () => {
        this.handleLocationError(true)
      })
    } else {
      // Browser doesn't support Geolocation
      this.handleLocationError(false)
    }

    this.input = document.getElementById('pac-input')
    this.searchBox = new window.google.maps.places.SearchBox(this.input)

    this.map.addListener('bounds_changed', () => {
      this.searchBox.setBounds(this.map.getBounds())
    })

    this.searchBox.addListener('places_changed', () => {
      const places = this.searchBox.getPlaces()

      if (places.length === 0) {
        return
      }

      if (!places[0].geometry) {
        const geocoder = new window.google.maps.Geocoder()
        const address = document.getElementById('pac-input').value

        geocoder.geocode({ address: address }, (results, status) => {
          if (status === window.google.maps.GeocoderStatus.OK) {
            this.latitud = results[0].geometry.location.lat()
            this.longitud = results[0].geometry.location.lng()
            this.updatePosition(results[0])
          }
        })
      } else {
        this.latitud = places[0].geometry.location.lat()
        this.longitud = places[0].geometry.location.lng()
        this.updatePosition(places[0])
      }
    })
  }
}
</script>

<style>
    .google-map {
        width: 100%;
        height: 70vh;
        margin: 0 auto;
        background: gray;
    }
</style>
